export class VenueDetails {
    id!:number;
    firmMPID!:string;
    venueMPID!:string;
    venueName!:string;
    venueFirmName!:string;
    isApproved:boolean = false;
    venueType!:string;
    approvedBy!: string | null;
    approvedDate!: string | null;
    createdDate!:string | null;
    createdUser!:string | null;
    updatedDate!:string | null;
    updatedUser!:string | null;
}